export class Platform {
  static isIOS = () => false
  static isAndroid = () => false
  static isNative = () => false
  static isWeb = () => true
}
